export function getCapabilities(userinfo = {}) {
    const caps = userinfo?.capabilities;
    return Array.isArray(caps) ? caps : [];
}

export function hasCapability(userinfo = {}, capability = '') {
    if (!capability) return false;
    return getCapabilities(userinfo).includes(String(capability));
}

export function hasAnyCapability(userinfo = {}, capabilities = []) {
    if (!Array.isArray(capabilities) || capabilities.length < 1) {
        return false;
    }
    return capabilities.some(cap => hasCapability(userinfo, cap));
}
